/* eanae-shop.js — Shop All + 카테고리 탭 리스팅.
   탭은 URL 해시(#skincare / #makeup / #haircare, 없으면 전체)로 진입하고 hashchange로 뒤로가기에 대응한다.
   탭 클릭은 history.replaceState로 해시만 갱신(히스토리 오염 방지).
   메이크업 탭의 쿠션 카드에는 셰이드 10개 원형이 노출된다. 담기 버튼 없음 — 카드 전체가 PDP 링크. */
(function () {
  "use strict";
  var mount = document.querySelector("[data-shop-mount]");
  if (!mount) return;

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }
  function hashTab(tabs) {
    var h = (location.hash || "").replace("#", "");
    for (var i = 0; i < tabs.length; i++) if (tabs[i].id === h) return h;
    return "all";
  }

  function render() {
    var D = window.EANAE_DATA;
    if (!D) return;
    var lang = window.EANAE_LANG ? window.EANAE_LANG.get() : "pt";
    function t(v) {
      if (v && typeof v === "object") return v[lang] != null ? v[lang] : v.pt;
      return v == null ? "" : v;
    }
    var UI = D.UI || {}, TABS = D.TABS || [], SH = D.SHADES || [];
    var tab = hashTab(TABS);
    var active = TABS.filter(function (x) { return x.id === tab; })[0] || TABS[0];
    var list = (D.PRODUCTS || []).filter(function (p) {
      return tab === "all" || p.group === tab;
    });

    var tabsHtml = TABS.map(function (x) {
      var on = x.id === tab;
      return (
        '<button type="button" class="ea-shop__tab' + (on ? " is-on" : "") + '"' +
        ' data-tab="' + esc(x.id) + '" aria-pressed="' + (on ? "true" : "false") + '">' +
        esc(t(x.label)) + "</button>"
      );
    }).join("");

    var cardsHtml = list.map(function (p) {
      var shades = "";
      if (p.isCushion) {
        shades =
          '<span class="ea-shop__shades">' +
          SH.map(function (s) {
            return '<span class="ea-shop__sw" title="' + esc(s.n) + '" style="background-color:' + esc(s.c) + '"></span>';
          }).join("") +
          "</span>";
      }
      return (
        '<a class="ea-scard" href="/?view=produto&id=' + esc(p.id) + '">' +
          '<span class="ea-scard__box">' +
            '<img class="ea-scard__img" src="' + esc(eanaeAsset(p.img)) + '" alt="' + esc(p.name) + '" loading="lazy">' +
          "</span>" +
          '<span class="ea-scard__meta">' +
            '<span class="ea-scard__name">' + esc(p.name) + "</span>" +
          "</span>" +
          '<span class="ea-scard__sub">' + esc(t(p.sub)) + "</span>" +
          '<span class="ea-scard__note">' + esc(t(p.note)) + "</span>" +
          shades +
        "</a>"
      );
    }).join("");

    // PT/EN은 단복수가 다르다 — "1 Produtos"가 아니라 "1 Produto".
    var count = list.length + " " + t(list.length === 1 ? UI.productsUnitOne : UI.productsUnit);

    mount.innerHTML =
      '<div class="ea-shop__wrap">' +
        '<h1 class="ea-shop__title">' + esc(t(active.title)) + "</h1>" +
        '<div class="ea-shop__tabs">' + tabsHtml + "</div>" +
        '<div class="ea-shop__bar">' +
          '<span class="ea-shop__count">' + esc(count) + "</span>" +
          '<span class="ea-shop__sort">' + esc(t(UI.sortBy)) + "</span>" +
        "</div>" +
        '<div class="ea-shop__grid">' + cardsHtml + "</div>" +
      "</div>";

    mount.querySelectorAll("[data-tab]").forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.getAttribute("data-tab");
        history.replaceState(null, "", id === "all" ? location.pathname + location.search : "#" + id);
        render();
      });
    });
  }

  function boot() {
    render();
    window.addEventListener("hashchange", render);
    window.addEventListener("eanae-lang-change", render);
  }
  if (window.EANAE_DATA) boot();
  else window.addEventListener("eanae-data-ready", boot);
})();
